var _path, _path2, _path3, _rect, _circle, _circle2, _circle3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1217 67.6529C49.1217 67.6529 47.4406 64.3958 47.0029 62.7952C46.5652 61.1946 46.7774 56.9386 46.7774 56.9386H14.8359L14.8359 62.4731C14.8359 62.4731 18.0502 67.6529 19.6574 67.6529C21.2646 67.6529 49.1217 67.6529 49.1217 67.6529Z",
    fill: "#E3EDC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5497 31.2243H60.3711V20.9244C61.0854 19.8934 63.1568 17.8314 65.7282 17.8314C68.2997 17.8314 70.014 20.3314 70.5497 21.5814V31.2243Z",
    fill: "#E3EDC3",
    stroke: "black",
    strokeWidth: 1.07143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.534 16.8772H28.0999C24.8511 16.8772 22.208 19.4958 22.208 22.7034L21.9666 55.6663H14.6612C14.1434 55.6663 13.748 56.1242 13.748 56.642V61.1782C13.748 65.4248 17.1465 68.8978 21.248 69.0883V69.1428H52.7715V69.0816C53.0059 69.0913 53.1479 69.1428 53.309 69.1428H53.3312C55.432 69.1306 57.442 68.2846 58.9192 66.7909C60.3965 65.2972 61.2201 63.2779 61.209 61.1771V32.3459H70.7254C71.2432 32.3459 71.6387 31.8772 71.6387 31.3598V23.0363C71.6415 21.4114 71.001 19.8514 69.8571 18.6972C68.7132 17.5431 67.1589 16.8888 65.534 16.8772ZM21.6582 67.2678H21.6518C18.3172 67.2678 15.623 64.5116 15.623 61.1771V57.5413H45.3887V61.1617C45.3851 62.2065 45.5879 63.2417 45.9853 64.2079C46.3828 65.1742 46.9671 66.0525 47.7048 66.7924C47.8636 66.9516 48.029 67.0334 48.1986 67.2678H21.6582ZM59.334 61.1763C59.334 64.5118 56.666 67.2678 53.3301 67.2678H53.3105C51.7003 67.2561 50.1602 66.6072 49.027 65.4631C47.8938 64.319 47.2598 62.7727 47.2637 61.1624V56.642C47.265 56.3893 47.1679 56.1461 46.9928 55.964C46.8178 55.7818 46.5786 55.675 46.3262 55.6663H23.8418L24.083 22.7102C24.083 20.5296 25.8849 18.7522 28.0999 18.7522H61.1078C60.0396 19.9241 59.334 21.4068 59.334 23.0614V61.1763ZM69.7637 23.053V30.4709H61.209V23.0599C61.209 20.7132 63.1611 18.7522 65.5062 18.7522H65.5325C66.662 18.7634 67.7412 19.2213 68.5341 20.0259C69.327 20.8305 69.7691 21.9162 69.7637 23.0458V23.053Z",
    fill: "#274642"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 34.1264,
    width: 20,
    height: 12.6437,
    rx: 5.45455,
    fill: "#274642"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2071,
    cy: 40.3332,
    r: 2.29885,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5625,
    cy: 40.3331,
    r: 2.29885,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.8848,
    cy: 29.2988,
    r: 2.29885,
    fill: "#274642"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9648,
    y: 30.6782,
    width: 1.83908,
    height: 3.44828,
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.c97b16e83c67856975fad03f74ac434e.svg";
export { ForwardRef as ReactComponent };